export const BUY = {
  teacher1: "https://luizawojtowiczwaga.elms.pl/s/roczny-abonament-1-lektor82113.html",
  teacher5: "https://luizawojtowiczwaga.elms.pl/s/roczny-abonament-dla-5-lektorow.html",
  teacher10: "https://luizawojtowiczwaga.elms.pl/s/roczny-abonament-dla-10-lektorow.html",
  owner: "https://luizawojtowiczwaga.elms.pl/s/roczny-abonament-wlasciciel.html",
  all: "https://luizawojtowiczwaga.elms.pl/s/roczny-abonament-1-mam-wszystko.html",
};

export const TEACHER_PLANS = [
  {
    id: "teacher1",
    label: "Dostęp dla 1 nauczyciela",
    audience: "Dla Ciebie",
    note: "Własny rozwój, własne tempo, cały rok dostępu.",
    value: 4098,
    price: 699,
    url: BUY.teacher1,
  },
  {
    id: "teacher5",
    label: "5 nauczycieli",
    audience: "Dla szkoły lub zespołu",
    note: "Pięć kont dla lektorów jednej szkoły. Wspólna biblioteka, wspólny język metodyczny.",
    value: 20490,
    price: 1499,
    url: BUY.teacher5,
  },
  {
    id: "teacher10",
    label: "10 nauczycieli",
    audience: "Dla większej szkoły",
    note: "Dziesięć kont dla lektorów. Do hospitacji, onboardingu i rozwoju całego zespołu.",
    value: 40980,
    price: 2499,
    url: BUY.teacher10,
  },
];

export const OWNER_PLAN = {
  id: "owner",
  label: "1 właścicielka / 1 właściciel",
  value: 4098,
  price: 1499,
  url: BUY.owner,
};

export const ALL_PLAN = {
  id: "all",
  label: "Nauczycielski + właścicielski",
  value: 8198,
  price: 1999,
  url: BUY.all,
};

const P = (slug) => `/products/${slug}.png`;

export const TEACHER_LIBRARY = [
  {
    category: "Metodyka i jakość lekcji",
    intro: "Fundament: jak uczyć, żeby uczniowie naprawdę zapamiętywali.",
    items: [
      {
        name: "Głębokie uczenie się",
        type: "Kurs",
        desc: "Jak przekuć tradycyjne metody w techniki, dzięki którym wiedza osadza się w pamięci na stałe.",
        url: "https://luizawojtowiczwaga.com/glebokieuczenie/",
        img: P("glebokie"),
      },
      {
        name: "Korepetycje z Metodyki",
        type: "Kurs",
        desc: "50 lekcji + 20 bonusowych: 70 odpowiedzi na najczęstsze pytania metodyczne, z zeszytem pracy własnej.",
        url: "https://luizawojtowiczwaga.com/korepetycjezmetodyki/",
        img: P("korepetycje"),
      },
      {
        name: "Masterclass – Praktyki z metodyki",
        type: "Kurs",
        desc: "Pierwsze w Polsce praktyki z metodyki online: 50 lekcji i zadanie do wykonania po każdej z nich.",
        url: "https://luizawojtowiczwaga.com/masterclass/",
        img: P("masterclass"),
      },
      {
        name: "Praktyczny trening mądrego testowania",
        type: "Kurs",
        desc: "Jak testować rzetelnie, oceniać sprawiedliwie i zrobić z testu narzędzie, które motywuje.",
        url: "https://luizawojtowiczwaga.com/testowanie/",
        img: P("testowanie"),
      },
    ],
  },
  {
    category: "Rozwój zawodowy i nawyki",
    intro: "Praca nad sobą: asertywność, kreatywność, czas i zmiana w małych krokach.",
    items: [
      {
        name: "Wielkie Metodyczne Wyzwanie: 52 nawyki w 52 tygodnie",
        type: "Kurs roczny",
        desc: "Jeden tydzień, jedna lekcja, jeden nawyk. Głęboka zmiana w nauczaniu rozłożona na cały rok.",
        url: "https://luizawojtowiczwaga.com/52nawyki/",
        img: P("52nawyki"),
      },
      {
        name: "Trening Asertywności",
        type: "Kurs",
        desc: "Jak chronić swoje granice w kontakcie z uczniem, rodzicem i dyrektorem. Asertywności da się nauczyć.",
        url: "https://luizawojtowiczwaga.com/treningasertywnosci/",
        img: P("asertywnosc"),
      },
      {
        name: "Design Thinking w edukacji",
        type: "Kurs",
        desc: "Wszystkie etapy metody krok po kroku: narzędzia, ćwiczenia i gotowe rozwiązania do wprowadzania innowacji.",
        url: "https://luizawojtowiczwaga.com/designthinking/",
        img: P("designthinking"),
      },
      {
        name: "Trening Kreatywności Uczniów",
        type: "Kurs",
        desc: "Trzy części szkolenia o tym, jak rozwijać twórcze myślenie uczniów na codziennych lekcjach.",
        url: "https://luizawojtowiczwaga.elms.pl/produkt/trening-kreatywnosci-uczniow/",
        img: P("kreatywnosc"),
      },
      {
        name: "Mistrzowskie Planowanie Czasu",
        type: "Kurs",
        desc: "Od chaosu i przeciążenia do lekcji, które są spokojne, skuteczne i naprawdę uczą.",
        url: "https://luizawojtowiczwaga.com/mistrzowskie-planowanie-czasu/",
        img: P("planowanie"),
      },
    ],
  },
  {
    category: "Praktyczne narzędzia",
    intro: "E-booki i kursoksiążki, po które sięgasz w dniu, w którym ich potrzebujesz.",
    items: [
      {
        name: "On-the-spot, ready or not",
        type: "E-book (EN)",
        desc: "20 rozdziałów tematycznych i 200 aktywności bez przygotowania, na każdą lekcję bez planu.",
        url: "https://luizawojtowiczwaga.com/on-the-spot-ready-or-not/",
        img: P("onthespot"),
      },
      {
        name: "100 Classroom Dilemmas",
        type: "E-book (EN)",
        desc: "100 rozdziałów z odpowiedziami na dylematy nauczycielskie, każdy z praktyczną wskazówką i zadaniem.",
        url: "https://luizawojtowiczwaga.com/100-classroom-dilemmas/",
        img: P("dilemmas"),
      },
      {
        name: "Mądre zadania bez przygotowania",
        type: "E-book",
        desc: "Gotowe, skuteczne aktywności lekcyjne, które nie wymagają ani minuty przygotowania.",
        url: "https://luizawojtowiczwaga.com/madre-zadania/",
        img: P("madrezadania"),
      },
      {
        name: "Metodyczne S.O.S. Luizy",
        type: "Kursoksiążka",
        desc: "100 rozdziałów z odpowiedziami na pytania, z którymi nauczyciele mierzą się najczęściej.",
        url: "https://luizawojtowiczwaga.com/metodyczne-sos/",
        img: P("sos"),
      },
      {
        name: "Metodyczny ActionBook",
        type: "ActionBook",
        desc: "52 tygodnie prostych, praktycznych działań porządkujących warsztat metodyczny.",
        url: "https://luizawojtowiczwaga.com/metodyczny-actionbook/",
        img: P("actionbook"),
      },
    ],
  },
];

export const OWNER_LIBRARY = [
  {
    category: "Zarządzanie szkołą",
    intro: "Procesy, kontrola, plan operacyjny na cały rok szkolny.",
    items: [
      {
        name: "Kompleksowy pakiet poradników „Szkoła pod Kontrolą”",
        type: "Pakiet e-poradników",
        desc: "Jak krok po kroku prowadzić szkołę językową, by mieć pełną kontrolę i spokój.",
        url: "https://luizawojtowiczwaga.com/szkola-pod-kontrola/",
        img: P("szkola"),
      },
      {
        name: "Roczny Kalendarz Zarządzania Szkołą Językową",
        type: "Plan operacyjny",
        desc: "Gotowy plan działań na każdy miesiąc roku szkolnego, od sierpnia do lipca.",
        url: "https://luizawojtowiczwaga.com/roczny-kalendarz-zarzadzania-szkola-jezykowa/",
        img: P("kalendarz"),
      },
    ],
  },
  {
    category: "Zespół, administracja i B2B",
    intro: "Sekretariat, który sprzedaje, i współpraca z firmami bez zaniżania cen.",
    items: [
      {
        name: "E-book „Superadmin”",
        type: "E-book",
        desc: "Standardy, procedury i narzędzia dla sekretariatu szkoły językowej, który przyciąga, wspiera i sprzedaje.",
        url: "https://luizawojtowiczwaga.com/superadmin/",
        img: P("superadmin"),
      },
      {
        name: "E-book „Kursy Językowe dla Firm. Profesjonalnie”",
        type: "E-book",
        desc: "Uporządkowany system pracy z klientem biznesowym: od oferty po raportowanie efektów.",
        url: "https://luizawojtowiczwaga.com/kursy-jezykowe-dla-firm-profesjonalnie/",
        img: P("firmy"),
      },
    ],
  },
  {
    category: "Rozwój właścicielki",
    intro: "Innowacje i granice: dwa kursy, które przydają się także w gabinecie dyrektora.",
    items: [
      {
        name: "Kurs „Design Thinking w Edukacji”",
        type: "Kurs",
        desc: "Metoda pracy kreatywnej do wprowadzania nowości i innowacji w szkole.",
        url: "https://luizawojtowiczwaga.com/designthinking/",
        img: P("designthinking"),
      },
      {
        name: "Kurs „Trening Asertywności”",
        type: "Kurs",
        desc: "Jak chronić granice w rozmowach z rodzicami, lektorami i klientami.",
        url: "https://luizawojtowiczwaga.com/treningasertywnosci/",
        img: P("asertywnosc"),
      },
    ],
  },
];

export const countItems = (lib) => lib.reduce((n, g) => n + g.items.length, 0);

export const FAQ = [
  {
    q: "Czy abonament jest na cały rok?",
    a: "Tak. Abonament daje dostęp do biblioteki przez 12 miesięcy od zakupu.",
  },
  {
    q: "Co dokładnie dostaję w ramach abonamentu?",
    a: "Dostęp do całej biblioteki wybranego abonamentu: kursów, kursoksiążek, e-booków i narzędzi wymienionych na tej stronie. Każdy kurs kończy się certyfikatem uczestnictwa, a prezentacje kursów można pobrać.",
  },
  {
    q: "Czy wszystkie produkty są dostępne od razu?",
    a: "Tak, wszystkie od ręki. Po zakupie masz dostęp do całej biblioteki od razu, bez etapów i odblokowywania.",
  },
  {
    q: "Czy mogę kupić abonament tylko dla jednej nauczycielki?",
    a: "Tak. Abonament nauczycielski w wariancie dla 1 osoby kosztuje 699 zł za rok.",
  },
  {
    q: "Czy właścicielka może korzystać z biblioteki nauczycielskiej?",
    a: "Abonament właścicielski obejmuje bibliotekę właścicielską. Jeżeli chcesz mieć także bibliotekę nauczycielską, odpowiedni jest abonament „Chcę mieć wszystko”.",
  },
  {
    q: "Co dokładnie zawiera „Chcę mieć wszystko”?",
    a: "Bibliotekę nauczycielską i bibliotekę właścicielską w jednym dostępie, przez 12 miesięcy.",
  },
  {
    q: "Jak długo mam dostęp?",
    a: "Przez 12 miesięcy od zakupu.",
  },
  {
    q: "Czy dostanę fakturę?",
    a: "Tak. W formularzu zamówienia zaznaczasz opcję „Proszę o wystawienie faktury” i podajesz dane: dla osoby prywatnej, firmy lub instytucji budżetowej, np. szkoły.",
  },
];

export const fmt = (n) =>
  String(n).replace(/\B(?=(\d{3})+(?!\d))/g, "\u00A0") + "\u00A0zł";
